import makeSlice from '@web/slices/deliveryManager/sliceMaker'

const slice = makeSlice()

export default slice.reducer
